/* This file shouldn't import anything from client side */

const URL_PREFIX = 'get-started'
const CDN_URL = 'https://cdn.babylonstatic.com/web-signup'
const BABYLON_CLIENT_NAME = 'web-signup'
const X_PLATFORM = 'web'

export { URL_PREFIX, CDN_URL, BABYLON_CLIENT_NAME, X_PLATFORM }
